import React from 'react';
import Icon from '../../../components/AppIcon';
import useInView from '../../../hooks/useInView';

const STEPS = [
  { title: 'Décrivez votre problème', desc: 'Quelques questions simples pour comprendre votre besoin.' },
  { title: 'Découvrez votre prix', desc: 'Le prix de l’intervention est affiché avant validation.' },
  { title: 'Choisissez votre créneau', desc: 'Sélectionnez le jour et l’heure qui vous conviennent.' },
  { title: 'Le technicien intervient', desc: 'Vous recevez la confirmation par SMS et e-mail.' },
];

const HowItWorks = () => {
  const [stepsRef, stepsVisible] = useInView({ threshold: 0.25 });

  return (
    <section className="marketing-section">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center mb-12">
          <p className="marketing-kicker mb-4">Simple et rapide</p>
          <h2 className="marketing-title text-3xl lg:text-5xl font-heading font-bold">
            Comment ça <span className="marketing-accent">marche</span> ?
          </h2>
        </div>

        <div ref={stepsRef} className="relative">
          <div aria-hidden="true" className="steps-line hidden md:block" />
          <ol className="relative grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-10">
            {STEPS.map((step, i) => (
              <li
                key={step.title}
                className={`reveal-on-scroll relative text-center ${stepsVisible ? 'is-visible' : ''}`}
                style={{ '--reveal-delay': `${i * 140}ms` }}
              >
                <div className="brand-mark w-16 h-16 mx-auto rounded-full text-xl font-extrabold text-white ring-8 ring-[rgba(6,24,33,0.9)]">
                  {i + 1}
                </div>
                <h3 className="mt-4 mb-2 text-base lg:text-lg font-semibold text-white">{step.title}</h3>
                <p className="marketing-muted text-sm leading-relaxed">{step.desc}</p>
              </li>
            ))}
          </ol>

          <div
            className={`reveal-on-scroll glass-panel mt-12 mx-auto max-w-xl rounded-2xl px-5 py-4 flex items-center gap-4 text-left ${stepsVisible ? 'is-visible' : ''}`}
            style={{ '--reveal-delay': `${STEPS.length * 140}ms` }}
          >
            <div className="w-12 h-12 shrink-0 rounded-xl flex items-center justify-center bg-emerald-400/15">
              <Icon name="BadgeEuro" size={26} className="text-emerald-400" />
            </div>
            <div>
              <p className="font-semibold text-white">Pas de mauvaise surprise</p>
              <p className="marketing-muted text-sm">Le prix est affiché avant que vous confirmiez.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
